import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import AlphaClassroomSaaS from "./pages/AlphaClassroomSaaS.jsx";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <AlphaClassroomSaaS />
    </BrowserRouter>
  </React.StrictMode>,
);
